import React, { useEffect, useState, useMemo } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Divider from "./Divider";
import axios from "axios";
import Home from "../../gallery/icons/home.png";
import Filter from "../../gallery/icons/filter.png";
import { initializeTagManager } from "../../TagManager";
import BusinessSearchModel from "../business/BusinessSearchModel";
import JobSerachModel from "../job/JobSerachModel";
import PropertySearchModel from "../property/PropertySearchModel";
import PopularCategories from "./PopularCategories";
import AdvertiseWithUs from "../template/AdvertiseWithUs";
import EventWithUs from "../events/EventWithUs";
import { useDispatch, useSelector } from "react-redux";
import { setActiveLink } from "../../app/features/nav/navSlice";
import SearchFilters from "./SearchFilters";
import SearchResults from "./SearchResults";
import SearchSkeleton from "./SearchSkeleton";
import { useQuery } from "react-query";

function SearchListing() {
  const dispatch = useDispatch();
  function toggleMobilenav() {
    var body = document.body;
    var hasClass = body.classList.contains("nav2-is-toggled");
    if (hasClass) {
      document.body.classList.remove("nav2-is-toggled");
      document.body.classList.remove("body-no-scroll");
      document.getElementById("ham").textContent = "menu";
    }
  }
  //used history hook to redirect the page
  const history = useHistory();
  //using location hook to get params from URL
  const location = useLocation();
  // var nearestLocation = 0;
  // var currentLocationFlag = 0;
  // var pillsimilar = null;
  let dataPage = useSelector((state) => state.nav.activeLink);
  let advertise = ""; // for dynamic advertisement portion
  // let nearBy = ""; // for dynamic near by services/events/jobs etc

  let queryParams = new URLSearchParams(location.search);
  let queryCategory = queryParams.get("category");
  let queryLocation = queryParams.get("location");
  let queryPage = queryParams.get("page");
  let queryLimit = queryParams.get("limit");
  let querySort = queryParams.get("sort");

  let queryType = "0";
  if (queryParams.get("type")) {
    queryType = queryParams.get("type");
  }
  let queryCTax = 0;
  if (queryParams.get("ctax")) {
    queryCTax = queryParams.get("ctax");
  }
  let querySharing = 0;
  if (queryParams.get("sharing")) {
    querySharing = queryParams.get("sharing");
  }
  let queryDeposit = 0;
  if (queryParams.get("deposit")) {
    queryDeposit = queryParams.get("deposit");
  }
  let queryGender = "3";
  if (queryParams.get("gender")) {
    queryGender = queryParams.get("gender");
  }
  let queryBills = 0;
  if (queryParams.get("bills")) {
    queryBills = queryParams.get("bills");
  }
  let queryTitle = "";
  if (queryParams.get("title")) {
    queryTitle = queryParams.get("title");
  }
  let queryJob = 0;
  if (queryParams.get("job")) {
    queryJob = queryParams.get("job");
  }
  let queryLevel = 0;
  if (queryParams.get("level")) {
    queryLevel = queryParams.get("level");
  }
  let queryDisclosed = 0;
  if (queryParams.get("disclosed")) {
    queryDisclosed = queryParams.get("disclosed");
  }
  let querySafe = 0;
  if (queryParams.get("safe")) {
    querySafe = queryParams.get("safe");
  }
  let queryFree = 0;
  if (queryParams.get("free")) {
    queryFree = queryParams.get("free");
  }

  //setting states for categories, locations and search
  const [parentCategory, setParentCategory] = useState();

  // Memoize search parameters to prevent unnecessary re-renders
  const searchParams = useMemo(
    () => ({
      category: queryCategory,
      location: queryLocation,
      page: queryPage,
      limit: queryLimit,
      sort: querySort,
      type: queryType,
      gender: queryGender,
      ctax: queryCTax,
      sharing: querySharing,
      deposit: queryDeposit,
      bills: queryBills,
      title: queryTitle,
      job: queryJob,
      level: queryLevel,
      disclosed: queryDisclosed,
    }),
    [queryCategory, queryLocation, queryPage, queryLimit, querySort, queryType, queryGender, queryCTax, querySharing, queryDeposit, queryBills, queryTitle, queryJob, queryLevel, queryDisclosed]
  );

  // Use React Query for categories
  const { data: categoriesData } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/categories",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          page: 1,
          limit: 300,
        },
      });
      return response.data.data;
    },
  });

  // Use React Query for locations
  const { data: locationsData } = useQuery({
    queryKey: ["locations"],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/locations",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          page: 1,
          limit: 300,
        },
      });
      return response.data.data;
    },
  });

  // Use React Query for search results
  const { data: searchData, isLoading: searchLoading } = useQuery({
    queryKey: ["search", searchParams],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: `${process.env.REACT_APP_BASE_URL}/api/search`,
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: searchParams,
      });
      return response.data;
    },
    enabled: !!(queryCategory || queryLocation), // Only run when we have search params
  });

  // Use React Query for category details
  const { data: categoryData } = useQuery({
    queryKey: ["category", queryCategory],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/categories/" + queryCategory,
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          page: 1,
          limit: 300,
        },
      });
      return response.data.data;
    },
    enabled: !!queryCategory,
  });

  useEffect(() => {
    initializeTagManager();
    toggleMobilenav();
  }, []);

  useEffect(() => {
    if (categoryData) {
      setParentCategory(categoryData);
    }
  }, [categoryData]);
  function handlePropSearch(queryParam, paramType) {
    if (paramType === "property") {
      queryType = queryParam;
    } else if (paramType === "gender") {
      queryGender = queryParam;
    } else if (paramType === "ctax") {
      queryCTax = queryParam;
    } else if (paramType === "sharing") {
      querySharing = queryParam;
    } else if (paramType === "deposit") {
      queryDeposit = queryParam;
    } else if (paramType === "bills") {
      queryBills = queryParam;
    } else if (paramType === "title") {
      queryTitle = queryParam;
    } else if (paramType === "job") {
      queryJob = queryParam;
    } else if (paramType === "level") {
      queryLevel = queryParam;
    } else if (paramType === "disclosed") {
      queryDisclosed = queryParam;
    } else if (paramType === "sort") {
      querySort = queryParam;
    } else if (paramType === "safe") {
      querySafe = queryParam;
    } else if (paramType === "free") {
      queryFree = queryParam;
    } else if (paramType === "category") {
      queryCategory = queryParam;
    }
    if (dataPage === "business") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}`);
    } else if (dataPage === "job") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&title=${queryTitle}&job=${queryJob}&level=${queryLevel}&disclosed=${queryDisclosed}`);
    } else if (dataPage === "property") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&type=${queryType}&gender=${queryGender}&ctax=${queryCTax}&sharing=${querySharing}&deposit=${queryDeposit}&bills=${queryBills}`);
    } else if (dataPage === "event") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&safe=${querySafe}&free=${queryFree}`);
    }
  }
  const handleRedirect = (value, type, value2 = null, type2 = null) => {
    queryPage = 1;
    if (type === "category") {
      queryCategory = value;
    }

    if (type === "location") {
      queryLocation = value;
    }
    if (type2) {
      queryLocation = value2;
    }

    if (dataPage === "business") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}`);
    } else if (dataPage === "job") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&title=${queryTitle}&job=${queryJob}&level=${queryLevel}&disclosed=${queryDisclosed}`);
    } else if (dataPage === "property") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&type=${queryType}&gender=${queryGender}&ctax=${queryCTax}&sharing=${querySharing}&deposit=${queryDeposit}&bills=${queryBills}`);
    } else if (dataPage === "event") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&safe=${querySafe}&free=${queryFree}`);
    }
  };
  const handlePagination = (event, p) => {
    event.preventDefault();
    queryPage = p;
    if (dataPage === "business") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}`);
    } else if (dataPage === "job") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&title=${queryTitle}&job=${queryJob}&level=${queryLevel}&disclosed=${queryDisclosed}`);
    } else if (dataPage === "property") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&type=${queryType}&gender=${queryGender}&ctax=${queryCTax}&sharing=${querySharing}&deposit=${queryDeposit}&bills=${queryBills}`);
    } else if (dataPage === "event") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&safe=${querySafe}&free=${queryFree}`);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleSort = (event, s) => {
    event.preventDefault();
    querySort = s;
    queryPage = 1;
    if (dataPage === "business") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}`);
    } else if (dataPage === "job") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&title=${queryTitle}&job=${queryJob}&level=${queryLevel}&disclosed=${queryDisclosed}`);
    } else if (dataPage === "property") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&type=${queryType}&gender=${queryGender}&ctax=${queryCTax}&sharing=${querySharing}&deposit=${queryDeposit}&bills=${queryBills}`);
    } else if (dataPage === "event") {
      history.push(`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}&safe=${querySafe}&free=${queryFree}`);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  function findRecordById(records, id) {
    return records.find((x) => parseInt(x.id) === parseInt(id));
  }
  // Memoize category and location options
  const categorySelectedOption = useMemo(() => {
    if (categoriesData && queryCategory) {
      const recordCat = categoriesData.find((c) => parseInt(c.id) === parseInt(queryCategory));
      if (recordCat) {
        return {
          label: recordCat.name,
          value: queryCategory,
        };
      }
    }
    return "";
  }, [categoriesData, queryCategory]);

  const locationSelectedOption = useMemo(() => {
    if (locationsData && queryLocation) {
      const recordLoc = findRecordById(locationsData, queryLocation);
      if (recordLoc) {
        return {
          label: recordLoc.name,
          value: queryLocation,
        };
      }
    }
    return "";
  }, [locationsData, queryLocation]);

  const breadcrumbLocation = useMemo(() => {
    if (locationSelectedOption && parseInt(queryLocation) === parseInt(1)) {
      return locationSelectedOption.label;
    } else if (locationSelectedOption) {
      return locationSelectedOption.label;
    }
    return "";
  }, [locationSelectedOption, queryLocation]);

  if (parentCategory) {
    if (parseInt(parentCategory.parent) === 4 || parseInt(queryCategory) === 4) {
      dispatch(setActiveLink("event"));
      advertise = <EventWithUs />;
    } else if (parseInt(parentCategory.parent) === 5 || parseInt(queryCategory) === 5 || parseInt(queryCategory) === 1) {
      dispatch(setActiveLink("business"));
      advertise = <AdvertiseWithUs />;
    } else if (parseInt(parentCategory.parent) === 3 || parseInt(queryCategory) === 3) {
      dispatch(setActiveLink("property"));
      advertise = <AdvertiseWithUs />;
    } else if (parseInt(parentCategory.parent) === 2 || parseInt(queryCategory) === 2) {
      dispatch(setActiveLink("job"));
      advertise = <AdvertiseWithUs />;
    }
  }

  return (
    <>
      {searchLoading && (
        <div className="container">
          <div className="inner-content">
            <div className="row bread-and-sort hidden-xs">
              <div className="col-lg-6 col-md-8 col-sm-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      ></div>
                    </li>
                    <li className="breadcrumb-item">
                      <div
                        style={{
                          height: "16px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "4px",
                          width: "60px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      ></div>
                    </li>
                    <li className="breadcrumb-item">
                      <div
                        style={{
                          height: "16px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "4px",
                          width: "150px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      ></div>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-lg-6 col-md-4 col-sm-12">
                <div className="refine hidden-xs hidden-md">
                  <section className="refine-section float-end">
                    <div
                      style={{
                        height: "20px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        width: "50px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    ></div>
                  </section>
                </div>
                <div className=" hidden-sm">
                  <section className="sort-by-section float-end">
                    <div
                      style={{
                        height: "20px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        width: "120px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        display: "inline-block",
                        marginLeft: "5px",
                      }}
                    ></div>
                  </section>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-12">
                <div className="row">
                  <div className="showing-result">
                    <div className="row">
                      <div className="col-9 p-0 m-0">
                        <div style={{ height: "20px", backgroundColor: "#f0f0f0", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }}></div>
                      </div>
                    </div>
                  </div>
                  {/* Filter skeleton - only show when dataPage is determined */}
                  {dataPage && (
                    <div className="toggle-search hidden-xs hidden-sm">
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div
                          style={{
                            height: "38px",
                            border: "1px solid #ced4da",
                            borderRadius: "0.375rem",
                            backgroundColor: "#fff",
                            display: "flex",
                            alignItems: "center",
                            padding: "0.375rem 0.75rem",
                            animation: "pulse 1.5s ease-in-out infinite",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <div
                              style={{
                                height: "1.2em",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                              }}
                            ></div>
                          </div>
                          <div
                            style={{
                              width: "0",
                              height: "0",
                              borderLeft: "0.3em solid transparent",
                              borderRight: "0.3em solid transparent",
                              borderTop: "0.3em solid #495057",
                              marginLeft: "auto",
                            }}
                          ></div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div
                          style={{
                            height: "38px",
                            border: "1px solid #ced4da",
                            borderRadius: "0.375rem",
                            backgroundColor: "#fff",
                            display: "flex",
                            alignItems: "center",
                            padding: "0.375rem 0.75rem",
                            animation: "pulse 1.5s ease-in-out infinite",
                          }}
                        >
                          <div style={{ width: "100%" }}>
                            <div
                              style={{
                                height: "1.2em",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                              }}
                            ></div>
                          </div>
                          <div
                            style={{
                              width: "0",
                              height: "0",
                              borderLeft: "0.3em solid transparent",
                              borderRight: "0.3em solid transparent",
                              borderTop: "0.3em solid #495057",
                              marginLeft: "auto",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Page-specific filter skeletons */}
                  {dataPage === "business" && (
                    <div className="card category-list hidden-xs hidden-sm">
                      <div className="card-body">
                        <h6 className="category-list-title">All categories</h6>
                        <ul className="list-unstyled">
                          {Array.from({ length: 8 }).map((_, index) => (
                            <li className="category-list-item" key={`filter-skeleton-${index}`}>
                              <div style={{ padding: "8px 0" }}>
                                <div
                                  style={{
                                    height: "16px",
                                    backgroundColor: "#f0f0f0",
                                    borderRadius: "4px",
                                    width: "70%",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                ></div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  {dataPage === "job" && (
                    <div className="property-search hidden-xs hidden-sm">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Job Title</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Type of Job</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Level</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Sort by</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <hr className="section-divider" />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="row radio-filter">
                            <div className="col-lg-9 col-md-9 col-9">
                              <label className="form-check-label">Hide jobs with undisclosed salary</label>
                            </div>
                            <div className="col-lg-3 col-md-3 col-3">
                              <div
                                style={{
                                  width: "40px",
                                  height: "24px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "12px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {dataPage === "property" && (
                    <div className="property-search hidden-xs hidden-sm">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Type of Property</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Gender preference</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <hr className="section-divider" />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="row radio-filter">
                            <div className="col-lg-9 col-md-9 col-9">
                              <label className="form-check-label">Council tax included</label>
                            </div>
                            <div className="col-lg-3 col-md-3 col-3">
                              <div
                                style={{
                                  width: "40px",
                                  height: "24px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "12px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              ></div>
                            </div>
                          </div>
                          <div className="row radio-filter">
                            <div className="col-lg-9 col-md-9 col-9">
                              <label className="form-check-label">Sharing allowed</label>
                            </div>
                            <div className="col-lg-3 col-md-3 col-3">
                              <div
                                style={{
                                  width: "40px",
                                  height: "24px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "12px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              ></div>
                            </div>
                          </div>
                          <div className="row radio-filter">
                            <div className="col-lg-9 col-md-9 col-9">
                              <label className="form-check-label">Deposit required</label>
                            </div>
                            <div className="col-lg-3 col-md-3 col-3">
                              <div
                                style={{
                                  width: "40px",
                                  height: "24px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "12px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              ></div>
                            </div>
                          </div>
                          <div className="row radio-filter">
                            <div className="col-lg-9 col-md-9 col-9">
                              <label className="form-check-label">Bills included</label>
                            </div>
                            <div className="col-lg-3 col-md-3 col-3">
                              <div
                                style={{
                                  width: "40px",
                                  height: "24px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "12px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {dataPage === "event" && (
                    <div className="property-search hidden-xs hidden-sm">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Type of Event</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <label className="form-label">Time</label>
                          <div style={{ marginBottom: "15px" }}>
                            <div
                              style={{
                                height: "38px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <hr className="section-divider" />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="row radio-filter">
                            <div className="col-lg-9 col-md-9 col-9">
                              <label className="form-check-label">Show only child-safe events</label>
                            </div>
                            <div className="col-lg-3 col-md-3 col-3">
                              <div
                                style={{
                                  width: "40px",
                                  height: "24px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "12px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              ></div>
                            </div>
                          </div>
                          <div className="row radio-filter">
                            <div className="col-lg-9 col-md-9 col-9">
                              <label className="form-check-label">Show only free events</label>
                            </div>
                            <div className="col-lg-3 col-md-3 col-3">
                              <div
                                style={{
                                  width: "40px",
                                  height: "24px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "12px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-9 col-md-12">
                <SearchSkeleton dataPage={dataPage} />
              </div>
            </div>
          </div>
        </div>
      )}
      {searchData && !searchLoading && (
        <div className="container">
          <div className="inner-content">
            <div className="row bread-and-sort hidden-xs">
              <div className="col-lg-6 col-md-8 col-sm-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <img src={Home} alt="" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/search?category=${queryCategory}&location=${queryLocation}&page=${queryPage}&limit=${queryLimit}&sort=${querySort}`} className="decorate-none">
                        {dataPage ? (dataPage === "job" ? "Jobs" : dataPage === "property" ? "Property" : dataPage === "business" ? "Business" : dataPage === "event" ? "Event" : "") : ""}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <span className="breadcrumb-active">{categorySelectedOption ? `Nepalese ${categorySelectedOption.label}` : "category"}</span> in <span className="breadcrumb-active">{breadcrumbLocation ? breadcrumbLocation : ""}</span>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-lg-6 col-md-4 col-sm-12">
                <div className="refine hidden-xs hidden-md">
                  <section className="refine-section float-end">
                    <a className="refine-xxs refine-text" href="/" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      <span className="hidden-xxs">Refine</span> &nbsp;
                      <img src={Filter} alt="" />
                    </a>
                  </section>
                </div>
                <div className="dropdown hidden-sm">
                  <section className="sort-by-section float-end">
                    <span className="sort-by">sort by</span>
                    <a href="/" className="decorate-none dropdown-toggle dropdown-sort" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      {querySort
                        ? querySort !== "null" && querySort === "name"
                          ? "A - Z" //querySort.charAt(0).toUpperCase() + querySort.slice(1)
                          : "Relevance"
                        : "Relevance"}
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <a onClick={(event) => handleSort(event, "name")} className={querySort ? (querySort === "name" ? "dropdown-item active-link" : "dropdown-item") : "dropdown-item"} href="/">
                          A - Z
                        </a>
                        <a onClick={(event) => handleSort(event, "null")} className={querySort ? (querySort === "null" ? "dropdown-item active-link" : "dropdown-item") : "dropdown-item"} href="/">
                          Relevance
                        </a>
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-12">
                <SearchFilters dataPage={dataPage} search={{ categories: categoriesData, locations: locationsData }} categorySelectedOption={categorySelectedOption} locationSelectedOption={locationSelectedOption} breadcrumbLocation={breadcrumbLocation} queryCategory={queryCategory} queryLocation={queryLocation} handleRedirect={handleRedirect} handlePropSearch={handlePropSearch} queryTitle={queryTitle} queryJob={queryJob} queryLevel={queryLevel} queryDisclosed={queryDisclosed} querySort={querySort} queryType={queryType} queryCTax={queryCTax} querySharing={querySharing} queryDeposit={queryDeposit} queryGender={queryGender} queryBills={queryBills} querySafe={querySafe} queryFree={queryFree} paginationData={searchData} />
                {dataPage === "business" && locationSelectedOption && categorySelectedOption && <BusinessSearchModel pageTitle={`Nepalese ${categorySelectedOption.label} in ${breadcrumbLocation}`} categories={categoriesData} locations={locationsData} categorySelectedOption={categorySelectedOption} locationSelectedOption={locationSelectedOption} />}
                {dataPage === "job" && locationSelectedOption && <JobSerachModel pageTitle={`Nepalese ${categorySelectedOption.label} in ${breadcrumbLocation}`} title={queryTitle ? queryTitle : ""} job={queryJob ? queryJob : 0} level={queryLevel ? queryLevel : 0} disclosed={queryDisclosed ? queryDisclosed : 0} sort={querySort ? querySort : null} locations={locationsData} locationSelectedOption={locationSelectedOption} />}
                {dataPage === "property" && locationSelectedOption && <PropertySearchModel pageTitle={`Nepalese ${categorySelectedOption.label} in ${breadcrumbLocation}`} type={queryType ? queryType : 0} gender={queryGender ? queryGender : 3} sort={querySort ? querySort : null} ctax={queryCTax ? queryCTax : 0} sharing={querySharing ? querySharing : 0} deposit={queryDeposit ? queryDeposit : 0} bills={queryBills ? queryBills : 0} locations={locationsData} locationSelectedOption={locationSelectedOption} />}
              </div>
              <div className="col-lg-9 col-md-12">
                <SearchResults
                  data={searchData.data}
                  dataPage={dataPage}
                  queryLocation={queryLocation}
                  queryPage={queryPage}
                  paginationData={(() => {
                    const { data, ...rest } = searchData;
                    return rest;
                  })()}
                  handlePagination={handlePagination}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <Divider />
      {dataPage === "business" && (
        <>
          <PopularCategories />
          <Divider />
        </>
      )}
      {advertise}
    </>
  );
}
export default SearchListing;
